

import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../../contexts/AppContext";


const AgentsSidebarWrapper = styled.div`
  width: 250px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;

  height: 100vh;
  position:sticky;
`;

const AgentsSidebarInnerWrapper = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const AgentsSidebarItems = styled.div`
  margin-top: 20px;
`;

const AgentsSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const AgentsSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const AgentsSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const AgentsSidebar = ({
  show = true,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
  onToggle = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);
  const { selectedClient } = useContext(
    AppContext
  );
  console.log("!!! SIDEBAR SELECTED CLIENT: ", selectedClient)

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <AgentsSidebarWrapper
      style={{
        width: show ? "250px" : "24px",
        transition: "width 0.3s ease-in-out",
        height: "100vh",
        marginTop: "-20px",
      }}

    >
      <button
        onClick={() => {
          onToggle();
        }}
        style={{
          width: "24px",
          height: "40px",
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
          borderTopRightRadius: ".25rem",
          borderBottomRightRadius: ".25rem",
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          right: "-24px",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <AgentsSidebarInnerWrapper
        style={{ display: show ? "flex" : "none" }}
      >
        <AgentsSidebarItems style={{ flexGrow: 0 }}>
          <AgentsSidebarItem className={isSelected("agents-list")} onClick={() => selectTab("agents-list")}>
            <span>
              <AgentsSidebarItemIcon icon="lucide:info" />
            </span>
            <AgentsSidebarItemText>Agents List</AgentsSidebarItemText>
          </AgentsSidebarItem>
          <AgentsSidebarItem className={isSelected("workflows")} onClick={() => selectTab("workflows")}>
            <span>
              <AgentsSidebarItemIcon icon="lucide:files" />
            </span>
            <AgentsSidebarItemText>Workflows</AgentsSidebarItemText>
          </AgentsSidebarItem>
        </AgentsSidebarItems>
      </AgentsSidebarInnerWrapper>
    </AgentsSidebarWrapper>
  );
};

export default AgentsSidebar;

